import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import {
  Box,
  Flex,
  Text,
  Spinner,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import UserProfileTabs from "./tabs/UserProfileTabs";

const MotionBox = motion(Box);

const GlassMorphismCard = ({ children, ...rest }) => {
  const bgColor = useColorModeValue(
    "rgba(255, 255, 255, 0.8)",
    "rgba(26, 32, 44, 0.8)"
  );
  const borderColor = useColorModeValue(
    "rgba(255, 255, 255, 0.5)",
    "rgba(255, 255, 255, 0.1)"
  );

  return (
    <Box
      bg={bgColor}
      backdropFilter="blur(10px)"
      borderRadius="2xl"
      boxShadow="xl"
      border="1px solid"
      borderColor={borderColor}
      overflow="hidden"
      transition="all 0.3s ease"
      _hover={{ boxShadow: "2xl" }}
      {...rest}
    >
      {children}
    </Box>
  );
};

const ViewUserProfile = () => {
  const { id } = useParams();
  const [profileData, setProfileData] = useState(null);
  const textColor = useColorModeValue("gray.700", "white");

  const [{ data, loading, error }, execute] = useAxios(
    { url: `/api/userprofiles/${id}`, method: "GET" },
    { manual: true }
  );

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await execute();
        setProfileData(response.data.data);
      } catch (err) {
        if (error?.code === "ERR_CANCELED") return;
        console.error("Error fetching group:", err);
      }
    };

    if (id) {
      fetchProfile();
    }
  }, [id]);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="400px">
        <Spinner size="xl" color="#f57d36" thickness="4px" />
      </Flex>
    );
  }

  if (error) {
    return (
      <GlassMorphismCard p={8}>
        <Text color="red.500" textAlign="center">
          Error loading group. Please try again.
        </Text>
      </GlassMorphismCard>
    );
  }

  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      w="100%"
    >
      {/* User Profile Tabs */}
      <UserProfileTabs id={id} profileData={profileData} />
    </MotionBox>
  );
};

export default ViewUserProfile;
